<template>
  <boxwrap class="permission-list--inner">
    <boxwrap-contents>
      <tbl :scrollable="true">
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="level-id"
              >
                등급
              </tbl-td>

              <tbl-td
                name="authority"
              >
                읽기/쓰기 권한
              </tbl-td>

              <tbl-td
                name="permission"
              >
                접근 권한 선택
              </tbl-td>

              <!-- tbl-td
                name="permission-id"
              >
                Permission ID
              </tbl-td -->

              <tbl-td
                name="action"
              >
                저장
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="permission in permissions"
              :key="permission.id"
            >
              <tbl-td name="level-id">
                {{permission.level_id}}
              </tbl-td>

              <tbl-td name="authority">
                <select
                  class="select-options"
                  v-model="permission.authority"
                >
                  <option  value="r">읽기</option>
                  <option value="rw">읽기/쓰기</option>
                </select>
              </tbl-td>

              <tbl-td name="permission">
                <div class="permission-list">
                  <div class="permission-list-item">
                    <checkbox label="전체 선택">
                      <input
                        @click="checkAll(permission.permission, permission.permissionSelectAll)"
                        v-model="permission.permissionSelectAll"
                        type="checkbox"
                      />
                    </checkbox>
                  </div>
                  <div
                    v-for="(item, itemKey) in permission.permission"
                    :ket="itemKey"
                    class="permission-list-item"
                  >
                    <checkbox :label="translate(translations, itemKey)">
                      <input
                        v-model="permission.permission[itemKey]"
                        type="checkbox"
                      />
                    </checkbox>
                  </div>
                </div>
              </tbl-td>

              <tbl-td name="action">
                <button
                  @click="edit(permission)"
                  class="btn--modify"
                  title="저장"
                >
                  <i class="ico--save"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>
      </tbl>
    </boxwrap-contents>
  </boxwrap>
</template>

<script type="text/javascript">
import Checkbox from '@/components/base/Checkbox'
import Modal from '@/components/base/Modal'
import { swal } from '@/assets/js/mixins/base/Swal'
import axios from 'axios'
import _ from 'lodash'

import { translations } from '@/assets/js/translations/PermissionList'
import { translate } from '@/assets/js/translations/Translate'

export default {
  name: 'permission',
  components: {
    Checkbox
  },

  mixins: [
    translate,
    swal
  ],

  data () {
    return {
      translations,
      permissions: []
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/`)
    }

    this.query = this.generate(this.query)
    this.search()
  },

  methods: {
    checkAll (list, flag) {
      const listArr = Object.keys(list)

      if (!flag) {
        listArr.forEach((item, itemKey) => {
          list[item] = true
        })
      } else {
        listArr.forEach((item, itemKey) => {
          list[item] = false
        })
      }
    },

    async search (query) {
      this.query = query || this.query
      this.status = this.$route.params.status
      try {
        let permissions = await axios
        .get('/admins/permission')

        this.permissions = _.orderBy(_.map(permissions.data, (perm)=>{
          return {
            authority: perm.authority,
            deleted_at: perm.deleted_at,
            id: perm.id,
            level_id: perm.level_id,
            permission: JSON.parse(perm.permission),
            permissionSelectAll: false
          }
        }), 'level_id')
      } catch (err) {
        console.log(err)
      }
    },

    async edit (item) {
      let success = async () => {
        let result = await axios
        .patch('/admins/permission/' + item.id, {
          permission: JSON.stringify(item.permission),
          authority: item.authority
        })
        if (result.status === 204) {
          this.$alert('success', '관리자 권한 수정을 완료하였습니다.', {}, '', '관리자 권한 수정' )
          // this.search()
        }
      }
      this.$alert('prompt', '관리자의 권한을 정말 변경 하시겠습니까?', {}, { success }, '관리자 권한 수정')
    }
  }
}
</script>